import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { Theme } from '@theme';
import { Scope } from '@utils';

const DefaultAvatar = ({ name, scope }: { name: string, scope: Scope.PRIVATE | Scope.PROFESSIONAL | Scope.GROUP | Scope.CATEGORY | Scope.HASHTAG }) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const color = scope === Scope.GROUP ? theme.colors.purple : (scope === Scope.CATEGORY ? theme.colors.orange : theme.colors.grey20)
  return (
    <View style={[styles.defaultContactAvatar, { borderColor: color }]}><Text style={[styles.defaultContactAvatarText, { color }]}>{name.charAt(0)}</Text></View>
  );
};

const getStyles = (theme: Theme) => StyleSheet.create({

    defaultContactAvatar: {
        width: 50,
        height: 50,
        borderRadius: 25,
        marginRight: 12,
        backgroundColor: theme.colors.grey20,
        borderWidth: 0.5,
        justifyContent: 'center',
        alignItems: 'center',
      },
    defaultContactAvatarText: {
        fontSize: theme.iconSize.jumbo,
        fontWeight: '600',
        color: theme.colors.grey20,
    },
});
export default DefaultAvatar;